import * as React from 'react';
import {FunctionComponent} from 'react';

import {GraphPillDto, GraphTimeSpan, Severity} from '../swagger';
import {ErrorsChart} from './ErrorsChart';
import {GraphTimeSpanComponent} from './GraphTimeSpan';

export interface TopbarComponentProps {
    chartItems?: GraphPillDto[];
    changeGraphTimeSpanHandler: (v: GraphTimeSpan) => void;
    currentGraphTimeSpan: GraphTimeSpan;
    logsIds: string[];
}

export const Topbar: FunctionComponent<TopbarComponentProps> =
    ({
         chartItems,
         changeGraphTimeSpanHandler,
         currentGraphTimeSpan,
         logsIds,
     }) => (
        <div
            className="bg-m-gray-3 hidden mb-5 -mt-5 -mx-6 px-6 py-5 lg:block lg:mb-8 lg:-mt-8 lg:-mx-10 lg:px-10 lg:py-8"
            id="topbar"
        >
            <ErrorsChart logsIds={logsIds} containerPadding={35} items={chartItems} graphTimeSpan={currentGraphTimeSpan}/>
            <div className="flex items-center mt-6">
                {/*<Button className='btn-secondary btn-sm mr-6'>
                <FontAwesomeIcon className='fill-current mr-4 text-m-gray-6' icon={faPause}/>
                Pause
            </Button>*/}
                <GraphTimeSpanComponent
                    currentGraphTimeSpan={currentGraphTimeSpan}
                    changeGraphTimeSpanHandler={(v) => changeGraphTimeSpanHandler(v)}
                />
                <div className="ml-20" id="errors-chart-legend">
                    <div className="inline-flex items-center mr-8">
                        <span className="list-item-bullet mr-3 Fatal"/>
                        <span className="text-Fatal">{Severity.Fatal}</span>
                    </div>
                    <div className="inline-flex items-center mr-8">
                        <span className="list-item-bullet mr-3 Error"/>
                        <span className="text-m-red">{Severity.Error}</span>
                    </div>
                    <div className="inline-flex items-center mr-8">
                        <span className="list-item-bullet mr-3 Warning"/>
                        <span className="text-m-yellow">{Severity.Warning}</span>
                    </div>
                    <div className="inline-flex items-center mr-8">
                        <span className="list-item-bullet mr-3 Info"/>
                        <span className="text-m-gray-6">{Severity.Info}</span>
                    </div>
                    <div className="inline-flex items-center mr-8">
                        <span className="list-item-bullet mr-3 Debug"/>
                        <span className="text-m-blue">{Severity.Debug}</span>
                    </div>
                    <div className="inline-flex items-center mr-8">
                        <span className="list-item-bullet mr-3 Trace"/>
                        <span className="text-m-green">{Severity.Trace}</span>
                    </div>
                </div>
                {/*<Button className='btn btn-secondary btn-sm ml-auto' onClick={() => {}}>
                <FontAwesomeIcon className='fill-current mr-4 text-m-gray-6' icon={faEyeSlash} />
                Hide chart
            </Button>*/}
            </div>
        </div>
    );
